<template>
  <div class="log-event-container">
    <div class="page-header">
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t("logEvent") }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
    </div>

    <v-card class="card2 main-card" style="margin-top: 1rem">
      <v-card-title class="d-flex align-center justify-space-between mb-2">
        <div class="d-flex align-center">
          <h3 class="text-h5 font-weight-bold text-primary">{{ $t("log_menagement") }}</h3>
        </div>
      </v-card-title>

      <v-card-text style="padding: 0">
        <v-row class="mb-4">
          <v-col cols="12">
            <!-- Date Range Panel -->
            <v-card flat class="filter-card mb-3">
              <v-card-item class="filter-header">
                <div
                  class="d-flex justify-space-between align-center cursor-pointer"
                >
                  <div class="d-flex align-center">
                    <v-icon class="mr-2" color="primary" size="20"
                      >mdi-calendar-range</v-icon
                    >
                    <h4 class="section-title mb-0">{{ $t("dateRange") }}</h4>
                  </div>
                  <v-btn
                    icon
                    variant="text"
                    size="small"
                    :color="expandDateFilter ? 'primary' : 'default'"
                  >
                  </v-btn>
                </div>
              </v-card-item>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-menu
                      v-model="startDateFlag"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      location="bottom"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ props }">
                        <v-text-field
                          v-model="startDate"
                          label="Start Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          variant="outlined"
                          class="modern-input"
                          density="comfortable"
                          v-bind="props"
                          color="primary"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="startDate"
                        @update:model-value="val => { startDate = formatDate(val); startDateFlag = false }"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-menu
                      v-model="endDateFlag"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      location="bottom"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ props }">
                        <v-text-field
                          v-model="endDate"
                          label="End Date"
                          prepend-icon="mdi-calendar"
                          readonly
                          variant="outlined"
                          class="modern-input"
                          density="comfortable"
                          v-bind="props"
                          color="primary"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="endDate"
                        color="primary"
                        @update:model-value="val => { endDate = formatDate(val); endDateFlag = false }"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- Filters Panel -->
            <v-card flat class="filter-card mb-3">
              <v-card-item
                @click="expandFilters = !expandFilters"
                class="filter-header"
              >
                <div
                  class="d-flex justify-space-between align-center cursor-pointer"
                >
                  <div class="d-flex align-center">
                    <v-icon class="mr-2" color="primary" size="20"
                      >mdi-filter-variant</v-icon
                    >
                    <h4 class="section-title mb-0">{{ $t("Filters") }}</h4>
                    <v-chip
                      v-if="hasActiveFilters"
                      size="small"
                      color="primary"
                      class="ml-2"
                      variant="tonal"
                    >
                      {{ activeFilterCount }} active
                    </v-chip>
                  </div>
                  <v-btn
                    icon
                    variant="text"
                    size="small"
                    :color="expandFilters ? 'primary' : 'default'"
                  >
                    <v-icon>{{
                      expandFilters ? "mdi-chevron-up" : "mdi-chevron-down"
                    }}</v-icon>
                  </v-btn>
                </div>
              </v-card-item>

              <v-expand-transition>
                <div v-show="expandFilters">
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <!-- API Name -->
                        <v-text-field
                          v-model="apiNameQuery"
                          variant="outlined"
                          density="comfortable"
                          label="API Name"
                          class="modern-input"
                          prepend-inner-icon="mdi-api"
                          clearable
                          color="primary"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <!-- Create By -->
                        <v-text-field
                          v-model="createByQuery"
                          variant="outlined"
                          density="comfortable"
                          label="Create By"
                          class="modern-input"
                          prepend-inner-icon="mdi-account"
                          clearable
                          color="primary"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <!-- Action -->
                        <v-select
                          v-model="actionQuery"
                          :items="[
                            { title: 'All', value: null },
                            ...actionList.map((item) => ({
                              title: item.name,
                              value: item.value,
                            })),
                            { title: 'Login', value: 'Login' },
                          ]"
                          variant="outlined"
                          density="comfortable"
                          label="Action"
                          class="modern-input"
                          prepend-inner-icon="mdi-gesture-tap"
                          clearable
                          color="primary"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <!-- Status Code -->
                        <v-select
                          v-model="statusCodeQuery"
                          :items="[
                            { title: 'All', value: null },
                            ...statusCode.map((item) => ({
                              title: item.name,
                              value: item.value,
                            })),
                          ]"
                          variant="outlined"
                          density="comfortable"
                          label="Status Code"
                          class="modern-input"
                          prepend-inner-icon="mdi-numeric"
                          clearable
                          color="primary"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <!-- Status API -->
                        <v-select
                          v-model="statusApiQuery"
                          :items="[
                            { title: 'All', value: null },
                            ...statusApi.map((item) => ({
                              title: item.name,
                              value: item.value,
                            })),
                          ]"
                          variant="outlined"
                          density="comfortable"
                          label="Status API"
                          class="modern-input"
                          prepend-inner-icon="mdi-state-machine"
                          clearable
                          color="primary"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </div>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>

        <v-divider class="mb-4"></v-divider>

        <div class="results-section">
          <div class="d-flex align-center justify-space-between mb-4">
            <h4 class="section-title">
              <v-icon class="mr-2" color="primary" size="20"
                >mdi-text-box-search</v-icon
              >
              {{ $t('Result') }}
            </h4>
            <div class="d-flex justify-end">
              <v-btn
                color="grey-lighten-1"
                variant="text"
                class="mr-2"
                @click="clearFilters"
                :disabled="!hasActiveFilters"
              >
                {{ $t("ClearAll") }}
              </v-btn>
              <v-btn
                color="primary"
                variant="elevated"
                size="large"
                prepend-icon="mdi-magnify"
                rounded="xl"
                class="search-button"
                @click="Search"
              >
                <span class="button-text">{{ $t("search") }}</span>
              </v-btn>
            </div>
            <!-- <div>
              <v-btn 
                color="primary" 
                variant="tonal" 
                size="small" 
                class="mx-1" 
                prepend-icon="mdi-refresh"
                @click="refreshData"
              >
                Refresh
              </v-btn>
              <v-btn 
                color="success" 
                variant="tonal" 
                size="small" 
                prepend-icon="mdi-microsoft-excel" 
              >
                Export
              </v-btn>
            </div> -->
          </div>

          <v-data-table-server
            :headers="headers"
            :items="listLog.logDetail"
            :loading="loading"
            :items-length="listLog.allRow"
            :items-per-page="itemsPerPage"
            @update:options="options = $event"
            class="modern-table"
          >
            <template v-slot:item.logType="{ item }">
              <div
                class="log-type-badge"
                :class="getLogTypeClass(item.columns.logType)"
              >
                <v-icon size="16" class="mr-1">{{
                  getLogTypeIcon(item.columns.logType)
                }}</v-icon>
                {{ item.columns.logType }}
              </div>
            </template>

            <template v-slot:item.timestamp="{ item }">
              <div class="timestamp-cell">
                <div class="date">{{ formatDate(item.columns.timestamp) }}</div>
                <div class="time">{{ formatTime(item.columns.timestamp) }}</div>
              </div>
            </template>

            <template v-slot:item.actions="{ item }">
              <div class="d-flex justify-center">
                <v-btn
                  icon
                  variant="text"
                  size="small"
                  color="primary"
                  @click="viewDetails(item)"
                  class="action-button mr-2"
                >
                  <v-icon>mdi-eye</v-icon>
                  <v-tooltip activator="parent" location="top"
                    >View Details</v-tooltip
                  >
                </v-btn>
              </div>
            </template>
          </v-data-table-server>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// import { useDeferredTrue } from 'naive-ui/es/_utils';
import dateUtils from "../plugins/date-utils";
import moment from "moment";
export default {
  name: "LogEvent",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  data: () => ({
    isInitialized: false,
    today: null,
    startDateFlag: false,
    endDateFlag: false,
    startDate: new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
    type: "All",
    userChannel: "",
    sessionID: "",
    totalRow: 0,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    apiNameQuery: null,
    actionQuery: null,
    statusCodeQuery: null,
    statusApiQuery: null,
    createByQuery: null,
    listLog: {
      allRow: 0,
      logDetail: [
        {
          id: 0,
          apiName: "",
          action: "",
          statusCode: 0,
          statusApi: 0,
          exception: "",
          createBy: "",
          createDate: "",
        },
      ],
    },
    expandDateFilter: false, // ปิดโดย default
    expandFilters: false, // ปิดโดย default
    loading: false,
    sortBy: [],
    sortDesc: [],
    isSearch: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    actionList: [
      { name: "Create", value: "Create" },
      { name: "Delete", value: "Delete" },
      { name: "Update", value: "Update" },
    ],
    statusCode: [
      { name: "OK", value: 200 },
      { name: "Bad request", value: 400 },
      { name: "Internal server error", value: 500 },
    ],
    statusApi: [
      { name: "Succesful", value: 0 },
      { name: "Error", value: 1 },
      { name: "System error", value: 2 },
      { name: "Duplicate", value: 3 },
      { name: "Less", value: 4 },
      { name: "Exception", value: 5 },
    ],
    headers: [
      {
        title: "No.",
        align: "center",
        value: "id",
        sortable: false,
        width: "5%",
      },
      {
        title: "Api Name",
        align: "center",
        value: "apiName",
        sortable: true,
        width: "20%",
      },
      {
        title: "Action",
        align: "center",
        value: "action",
        sortable: true,
        width: "10%",
      },
      {
        title: "Status code",
        align: "center",
        value: "statusCode",
        sortable: true,
        width: "10%",
      },
      {
        title: "Status api",
        align: "center",
        value: "statusApi",
        sortable: true,
        width: "10%",
      },
      {
        title: "Message",
        align: "center",
        value: "exception",
        sortable: false,
        width: "25%",
      },
      {
        title: "Create by",
        align: "center",
        value: "createBy",
        sortable: true,
        width: "10%",
      },
      {
        title: "Create date",
        align: "center",
        value: "createDate",
        sortable: true,
        width: "10%",
      },
    ],
  }),
  watch: {
    options: {
      handler() {
        if (!this.isInitialized) return;
        this.fetchLog();
      },
      deep: true,
    },
  },
  mounted() {
    let self = this;
    self.GetDate();
    var date = new Date();
    self.startDate = self.convertDateToString2(date);
    self.endDate = self.convertDateToString2(date);
    self.Search();
    this.isInitialized = true;
  },
  computed: {
    // เพิ่ม computed properties
    hasActiveFilters() {
      return (
        this.apiNameQuery ||
        this.createByQuery ||
        this.actionQuery ||
        this.statusCodeQuery ||
        this.statusApiQuery
      );
    },

    activeFilterCount() {
      let count = 0;
      if (this.apiNameQuery) count++;
      if (this.createByQuery) count++;
      if (this.actionQuery) count++;
      if (this.statusCodeQuery) count++;
      if (this.statusApiQuery) count++;
      return count;
    },
  },
  methods: {
    clearFilters() {
      this.apiNameQuery = null;
      this.createByQuery = null;
      this.actionQuery = null;
      this.statusCodeQuery = null;
      this.statusApiQuery = null;
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    convertDateToString2(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },
    formatDate(dateInput) {
      if (!dateInput) {
        return "";
      }
      if (
        typeof dateInput === "string" &&
        /^\d{4}-\d{2}-\d{2}$/.test(dateInput)
      ) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;
      return date;
    },
    formatNumber(value) {
      return value.toLocaleString();
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!
      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      this.today = dd + "/" + mm + "/" + yyyy;
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.options.page = 1;
      self.fetchLog();
    },
    fetchLog() {
      let self = this;
      const { page, itemsPerPage } = self.options;
      self.loading = true;
      self.sortBy =
        self.options.sortBy == undefined || self.options.sortBy.length == 0
          ? null
          : self.options.sortBy[0];
      self.sortDesc =
        self.options.sortDesc == undefined || self.options.sortDesc.length == 0
          ? null
          : self.options.sortDesc[0];
      var tempData = {
        startDate: self.startDate,
        stopDate: self.endDate,
        page: page,
        pageResult: itemsPerPage,
        apiNameQuery: self.apiNameQuery,
        actionQuery: self.actionQuery,
        statusCodeQuery: self.statusCodeQuery,
        statusApiQuery: self.statusApiQuery,
        createByQuery: self.createByQuery,
        sortBy: self.sortBy,
        sortDesc: self.sortDesc,
      };
      self.$call.GetEventLog(
        tempData,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listLog.logDetail = dataResponse.data.listData;
            if (self.listLog.logDetail.length != 0) {
              self.listLog.allRow = dataResponse.data.allRow;
              self.listLog.logDetail.forEach((log) => {
                log.createDate = self.Utc2Thai(log.createDate);
                log.statusCode = log.statusCode == 200 ? "OK" : log.statusCode;
                log.statusCode =
                  log.statusCode == 400 ? "Bad request" : log.statusCode;
                log.statusCode =
                  log.statusCode == 500
                    ? "Internal server error"
                    : log.statusCode;

                log.statusApi =
                  log.statusApi == 0 ? "Succesful" : log.statusApi;
                log.statusApi = log.statusApi == 1 ? "Error" : log.statusApi;
                log.statusApi =
                  log.statusApi == 2 ? "System error" : log.statusApi;
                log.statusApi =
                  log.statusApi == 3 ? "Duplicate" : log.statusApi;
                log.statusApi = log.statusApi == 4 ? "Less" : log.statusApi;
                log.statusApi =
                  log.statusApi == 5 ? "Exception" : log.statusApi;

                log.exception = log.exception == null ? "-" : log.exception;
              });
            }
            self.loading = false;
            self.isSearch = false;
          }
        },
        (errorResource) => {
          self.loading = false;
          console.error(errorResource);
        }
      );
    },
    Utc2Thai(Input) {
      var utc = new Date(Input);
      var local = new Date(utc.getTime() + 7 * 60 * 60 * 1000);
      var day = String(local.getDate()).padStart(2, "0");
      var month = String(local.getMonth() + 1).padStart(2, "0");
      var year = String(local.getFullYear()).slice();
      var hours = String(local.getHours()).padStart(2, "0");
      var minutes = String(local.getMinutes()).padStart(2, "0");
      // Format the date as dd/mm/yy hh:mm
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    getExceptionStyle(exception) {
      return exception == "-" ? { textAlign: "center" } : { textAlign: "left" }; //make exception placeholder center when it's was used
    },
    refreshData() {
      this.fetchLogs();
    },
    viewDetails(item) {
      this.selectedLog = item.columns;
      this.dialogDetail = true;
    },
  },
};
</script>
<style scoped>
.log-event-container {
  background: #f7fafc;
  min-height: 100vh;
  padding: 16px;
}

.main-card {
  border-radius: 16px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
  overflow: hidden;
}

.section-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #2d3748;
  display: flex;
  align-items: center;
}

.filter-section {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  height: 100%;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04); */
}

.modern-input :deep(.v-field) {
  border-radius: 12px !important;
  background-color: #f8fafc !important;
  transition: all 0.2s ease;
}

.modern-input :deep(.v-field:hover) {
  background-color: #f1f5f9 !important;
}

.modern-input :deep(.v-field--focused) {
  background-color: #ffffff !important;
  box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.2) !important;
}

.modern-input :deep(.v-field__input) {
  padding: 8px 12px !important;
}

.search-button {
  background: linear-gradient(135deg, #4ade80 0%, #16a34a 100%) !important;
  box-shadow: 0 4px 14px rgba(22, 163, 74, 0.25) !important;
  transition: all 0.3s ease !important;
  min-width: 120px;
}

.search-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(22, 163, 74, 0.35) !important;
}

.button-text {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.results-section {
  padding: 0 16px 16px 16px;
}

.modern-table {
  border-radius: 12px;
  overflow: hidden;
}

.modern-table :deep(th) {
  background-color: #f8fafc !important;
  color: #475569 !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  font-size: 0.8125rem !important;
  letter-spacing: 0.5px !important;
  height: 48px !important;
}

.modern-table :deep(tr) {
  border-bottom: 1px solid #f1f5f9 !important;
  height: 52px !important;
}

.modern-table :deep(tr:hover) {
  background-color: rgba(241, 245, 249, 0.7) !important;
}

.log-type-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 40px;
  font-size: 0.8125rem;
  font-weight: 500;
}

.log-type-badge.type-info {
  background-color: #e0f2fe;
  color: #0284c7;
}

.log-type-badge.type-warning {
  background-color: #fef3c7;
  color: #d97706;
}

.log-type-badge.type-error {
  background-color: #fee2e2;
  color: #dc2626;
}

.timestamp-cell {
  display: flex;
  flex-direction: column;
}

.timestamp-cell .date {
  font-weight: 500;
}

.timestamp-cell .time {
  font-size: 0.8125rem;
  color: #64748b;
}

.action-button {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.action-button:hover {
  transform: translateY(-2px);
  opacity: 0.9;
}

.modern-dialog :deep(.v-card) {
  border-radius: 16px !important;
  overflow: hidden;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: linear-gradient(to right, #f8fafc, #f1f5f9);
}

.dialog-title {
  color: #1e293b;
  font-weight: 700;
  margin: 0;
}

.dialog-content {
  padding: 24px !important;
}

.log-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

.detail-group {
  margin-bottom: 16px;
}

.detail-label {
  font-weight: 600;
  font-size: 0.8125rem;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.detail-value {
  color: #111827;
  font-size: 0.9375rem;
}

.message-container {
  margin-bottom: 16px;
}

.message-content {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
  color: #1f2937;
  white-space: pre-wrap;
  word-break: break-word;
}

.session-id {
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.8125rem;
  background: #f1f5f9;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-block;
}

.dialog-actions {
  padding: 16px 24px !important;
  border-top: 1px solid #f1f5f9;
}

@media (max-width: 960px) {
  .search-button {
    width: 100%;
    margin-top: 16px;
  }
}

@media (max-width: 600px) {
  .log-event-container {
    padding: 8px;
  }

  .filter-section {
    padding: 12px;
  }

  .section-title {
    font-size: 1rem;
  }
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead th) {
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
</style>
